import type { PrefetchContext } from 'src/shared/prefetch';

import { prefetch as prefetchFooter } from './footer';
import { prefetch as prefetchHeader } from './header';

export async function prefetch(context: PrefetchContext): Promise<void> {
	await Promise.all([prefetchHeader(context), prefetchFooter(context)]);
}
